const setWidth = () => {
  const blocks = document.querySelectorAll('.client-profiles-block')
  if (blocks) {
    ;[...blocks].map((block) => {
      const gap = 30
      const mainWidth = document.documentElement.clientWidth

      const img = block.querySelector('.client-profiles-block__image-wrapper')
      const imgEl = img.querySelector('img')
      const imgWidth = img.clientWidth

      const container = document.querySelector('.entry-content--main')
      const containerWidth = container.clientWidth

      const spaceWidth = (mainWidth - containerWidth) / 2

      if (window.matchMedia('(max-width: 991.98px)').matches) {
        block.style.width = `${mainWidth}px`
        block.style.marginLeft = `calc(${-mainWidth / 2}px + 50%)`
        return
      }

      if (window.matchMedia('(max-width: 1199.98px)').matches) {
        const width = spaceWidth + imgWidth
        imgEl.style.width = `${width}px`
        block.style.width = `${mainWidth}px`
        block.style.marginLeft = `calc(${-mainWidth / 2}px + 50%)`
        return
      }

      const width = spaceWidth + imgWidth - gap
      imgEl.style.width = `${width}px`
    })
  }
}

setWidth()
window.addEventListener('load', setWidth)
window.addEventListener('resize', setWidth)
